import { useRef } from 'react';
import { useVirtualizer } from '@tanstack/react-virtual';
import type { QueryResult } from '../engine/client';

export function ResultsTable({ result }: { result: QueryResult }) {
  const parentRef = useRef<HTMLDivElement>(null);
  const virtualizer = useVirtualizer({ count: result.rows.length, getScrollElement: () => parentRef.current, estimateSize: () => 31, overscan: 12 });
  return <div ref={parentRef} className="result-wrap" role="region" aria-label="Query results" tabIndex={0}>
    <div style={{ height: virtualizer.getTotalSize() + 34, minWidth: Math.max(700, result.columns.length * 160), position: 'relative' }}>
      <table className="result-table" style={{ position: 'absolute', inset: 0, height: 'auto' }}>
        <thead><tr>{result.columns.map((column)=><th key={column}>{column}</th>)}</tr></thead>
        <tbody>
          {virtualizer.getVirtualItems().map((item) => {
            const row = result.rows[item.index]!;
            return <tr key={item.key} style={{ position:'absolute', transform:`translateY(${item.start + 34}px)`, height:item.size, display:'table', tableLayout:'fixed', width:'100%' }}>
              {result.columns.map((column)=><td key={column} title={String(row[column] ?? '')}>{formatValue(row[column])}</td>)}
            </tr>;
          })}
        </tbody>
      </table>
    </div>
  </div>;
}

function formatValue(value: unknown): string {
  if (value == null) return '∅';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}
